import React from 'react'

const PrimaryAdvertisement = ({
  advertisements,
  hidePrivateAds = false
}) => {
  const primaryAdvertisement = advertisements.find(ad => ad.primary)
  if (hidePrivateAds && !primaryAdvertisement?.publicly_visible) {
    return null
  }
  if (primaryAdvertisement) {
    return (
      <div>
        <a href={primaryAdvertisement.url} target='_blank' rel='noopener noreferrer'>
          <img src={primaryAdvertisement.primary_image_url} />
        </a>
      </div>
    )
  }

  return null
}

export default PrimaryAdvertisement
